import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-taskplan",
  "use": "icon-nav-taskplan-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-nav-taskplan\">\r\n<g>\r\n\t<path d=\"M186.5,26.6h-16.8v20c0,7.3-6.1,13.4-13.5,13.4H47.7c-7.4,0-13.5-6-13.5-13.4v-20H13.5C6.1,26.6,0,32.6,0,39.9v146.7\r\n\t\tC0,194,6.1,200,13.5,200h173.1c7.4,0,13.5-6,13.4-13.4V39.9C200,32.6,193.9,26.6,186.5,26.6z M153.7,113.6L96.8,163\r\n\t\tc-5.3,4.6-13.7,4.6-19,0l-31.6-27.4c-5.3-4.4-5.3-11.8,0-16.4c5.3-4.6,13.7-4.6,19,0l22.1,19.3l47.4-41.3c5.3-4.6,13.7-4.6,19,0\r\n\t\tC159,101.8,159,109.1,153.7,113.6z\" />\r\n\t<path d=\"M107.2,0H93.8c-4.1,0-8.2,1.5-11.3,4.2c-4.4,3.8-9.6,7.7-29.9,22.4v6.7c0,7.3,6.1,13.4,13.5,13.4h67.7\r\n\t\tc7.6,0,13.5-5.9,13.5-13.4v-6.7C128,12.5,122.7,8.1,118.7,4.5C115.6,1.6,111.5,0,107.2,0z M100,39c-7.8,0-14.2-6.4-14.2-14.2\r\n\t\ts6.4-14.2,14.2-14.2s14.2,6.2,14.2,14.2C114.2,32.6,107.8,39,100,39z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/nav/nav-taskplan.svg
// module id = Oa7d
// module chunks = 13